import { Directive, TemplateRef } from '@angular/core';


export class TabTitleDirective {
  constructor(private templateRef: TemplateRef<any>) { }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[ng-template[chTabTitle]]'
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: TemplateRef, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
